
import { getStoredChildren, storeChildren } from './children';
import { getStoredQuotes, storeQuotes } from './quotes';
import { getStoredMilestones, storeMilestones } from './milestones';
import { clearAllData } from './helpers';
import { logger } from '@/utils/logger';

// Export data
export const exportData = async (): Promise<string> => {
  try {
    const children = await getStoredChildren();
    const quotes = await getStoredQuotes();
    const milestones = await getStoredMilestones();
    
    const data = {
      children,
      quotes,
      milestones
    };
    
    return JSON.stringify(data);
  } catch (error) {
    logger.error('Error in exportData:', error);
    return '{}';
  }
};

// Import data
export const importData = async (jsonData: string): Promise<boolean> => {
  try {
    const data = JSON.parse(jsonData);
    
    // Clear existing data first
    await clearAllData();
    
    // Import children
    if (data.children && Array.isArray(data.children)) {
      for (const child of data.children) {
        await storeChildren({
          name: child.name,
          birthdate: child.birthdate,
          photoUrl: child.photoUrl
        });
      }
    }
    
    // Get newly created children to map IDs
    const newChildren = await getStoredChildren();
    const childMap = new Map();
    data.children.forEach((oldChild, index) => {
      if (newChildren[index]) {
        childMap.set(oldChild.id, newChildren[index].id);
      }
    });
    
    // Import quotes
    if (data.quotes && Array.isArray(data.quotes)) {
      for (const quote of data.quotes) {
        const newChildId = childMap.get(quote.childId);
        if (newChildId) {
          await storeQuotes({
            content: quote.content,
            childId: newChildId,
            date: quote.date,
            context: quote.context
          });
        }
      }
    }
    
    // Import milestones
    if (data.milestones && Array.isArray(data.milestones)) {
      for (const milestone of data.milestones) {
        const newChildId = childMap.get(milestone.childId);
        if (newChildId) {
          await storeMilestones({
            content: milestone.content,
            childId: newChildId,
            date: milestone.date,
            context: milestone.context
          });
        }
      }
    }
    
    return true;
  } catch (error) {
    logger.error('Error importing data:', error);
    return false;
  }
};
